"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useFeatureFlags } from "@shared-components/feature-flag-context";
import type { AppFeatureEnumType } from "@shared-database/schema";
import { Badge } from "@shared-components/shadcn/badge";
import { cn } from "@shared-utils/ui";
export type FeatureFlagFallbackProps = {
  feature: AppFeatureEnumType;
  fallback?: React.ReactNode;
  children: React.ReactNode;
};
export const DegradedFeatureFlagFallback = props => {
  const $ = _c(9);
  const featureFlags = useFeatureFlags();
  if ("contextUnAvailable" in featureFlags && featureFlags.contextUnAvailable || "featureIsDegraded" in featureFlags && !featureFlags.featureIsDegraded) {
    let t0;
    if ($[0] !== props.children) {
      t0 = <>{props.children}</>;
      $[0] = props.children;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  } else {
    const {
      reasons
    } = featureFlags as {
      featureIsDegraded: boolean;
      currentFeature: AppFeatureEnumType;
      reasons: string[];
    };
    const t0 = props.children;
    let t1;
    if ($[2] !== reasons) {
      t1 = reasons.map(_temp);
      $[2] = reasons;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== t1) {
      t2 = <div className="ml-7 flex max-w-full flex-wrap gap-2">{t1}</div>;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== props.children || $[7] !== t2) {
      t3 = <>{t0}{t2}</>;
      $[6] = props.children;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
};
function _temp(reason, idx) {
  return <Badge key={idx} className={cn("h-auto max-w-full items-start border-sec-black/20 bg-sec-bright-pink py-0.5 text-black dark:bg-sec-light-pink dark:text-black")}><span className="text-sm whitespace-normal break-words leading-tight">{reason}</span></Badge>;
}